import cn from 'classnames'
import { FC, ReactNode, useEffect, useState } from 'react'

import styles from './Tooltip.module.scss'

interface IProps {
  horizontal?: boolean
  children?: ReactNode
}

const Tooltip: FC<IProps> = ({ horizontal = true, children }) => {
  const [error, setError] = useState(children)
  useEffect(() => {
    if (children) setError(children)
  }, [children])
  return (
    <div className={cn(styles.tooltip, { [styles.horizontal]: horizontal })}>
      <div className={cn(styles.text, 'front-error')}>{error}</div>
    </div>
  )
}

export default Tooltip
